import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JiraExportStatus {
    is_completed: boolean;
    status: 'loading' | 'in_progress' | 'completed' | 'failed' | 'idle';
    last_synced_at?: string;
    message?: string;
}

interface BackgroundWorkerState {
    jira_export: {
        [projectId: string]: JiraExportStatus;
    };
}

const initialState: BackgroundWorkerState = {
    jira_export: {},
};

export const backgroundWorkerSlice = createSlice({
    name: 'background_worker',
    initialState,
    reducers: {
        updateJiraExportStatus: (
            state,
            action: PayloadAction<{ projectId: string; status: Partial<JiraExportStatus> }>
        ) => {
            const { projectId, status } = action.payload;
            if (!state.jira_export[projectId]) {
                state.jira_export[projectId] = {
                    is_completed: false,
                    status: 'idle',
                };
            }
            state.jira_export[projectId] = {
                ...state.jira_export[projectId],
                ...status,
            };
        },
        resetJiraExportStatus: (state, action: PayloadAction<string>) => {
            delete state.jira_export[action.payload];
        },
    },
});

export const { updateJiraExportStatus, resetJiraExportStatus } = backgroundWorkerSlice.actions;

export default backgroundWorkerSlice.reducer;
